/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureConnectAccountRequest {
  /**
  * The account type - restore or source
  */
  'accountType': AzureConnectAccountRequestAccountTypeEnum;
  /**
  * The tenant ID
  */
  'tenantId': string;
  /**
  * The subscription ID. This field is required if managementGroupId is not provided. (Cannot be provided together with managementGroupId.) 
  */
  'subscriptionId'?: string;
  /**
  * Optional. If provided, the restore account will be scoped to this resource group name. Relevant for restore accounts only. (Cannot be provided together with managementGroupId.) 
  */
  'resourceGroupName'?: string;
  /**
  * The management group ID. This field is required if subscriptionId is not provided. (Cannot be provided together with subscriptionId.) 
  */
  'managementGroupId'?: string;
  /**
  * The location (region) in which the resources were created. Relevant for restore accounts only.
  */
  'location'?: string;
  /**
  * The application ID
  */
  'applicationId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountType",
      "baseName": "accountType",
      "type": "AzureConnectAccountRequestAccountTypeEnum",
      "format": ""
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": "string"
    },
    {
      "name": "managementGroupId",
      "baseName": "managementGroupId",
      "type": "string",
      "format": "string"
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return AzureConnectAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AzureConnectAccountRequestAccountTypeEnum {
  Restore = 'Restore',
  Source = 'Source'
}

